import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getGlobalLocations } from '../../../../shared/components/Locations/Locations.selectors'
import { getRepresentedLocations } from '../../../../shared/components/Login/Login.selectors'
import LocationExpiryModal from './LocationExpiry.component';
import { withAccessRights, withRouter } from '../../../../shared/hoc';
import { confirmLocation } from './LocationExpiry.actions';
import { injectIntl } from 'react-intl';
import { getIsLocationExpired } from './LocationExpiry.utils';
import { isLocalAdmin } from '../../../config/staff';
import { settings as settingsConfig } from '../../../config/api';

class LocationExpiryContainer extends React.Component {
  state = {
    expiredLocation: null,
    isModalManuallyClosed: false
  }

  componentDidUpdate() {
    const isSettingsPage = this.props.location.pathname.includes(settingsConfig.path)

    if (isSettingsPage || this.state.isModalManuallyClosed) {
      if (this.state.expiredLocation) {
        this.setState({ expiredLocation: null })
      }

      return;
    }

    const expiredLocation = this.getExpiredLocation() || null;

    if (expiredLocation !== this.state.expiredLocation) {
      this.setState({ expiredLocation })
    }
  }

  canConfirmExpiredLocation = (location) => {
    const locationId = location.id;
    const locationRights = this.props.roles?.[locationId]

    // Only local admin
    if (locationRights) {
      return isLocalAdmin(locationRights);
    }
  }

  getExpiredLocation() {
    const {currentLocationId: currentLocationIdFromProps, globalLocations, representedLocations} = this.props;

    if (!globalLocations.length || !representedLocations.length) {
      return;
    }

    const locationId = currentLocationIdFromProps ? Number(currentLocationIdFromProps) : null;
    const mapLocations = new Map(globalLocations.map(l => [l.id, l]));
    const userLocations = [...representedLocations]
      .sort((a, b) => {
        if (!locationId) return 0; 
        if (a.id === locationId) return -1; 
        if (b.id === locationId) return 1;
        return 0;
      })
      .map(l => mapLocations.get(l.id))
      .filter(Boolean);
    
    return userLocations
      .filter(this.canConfirmExpiredLocation)
      .find(getIsLocationExpired)
  }

  updateLocation = () => {
    if (this.state.expiredLocation) {
      this.setState({ expiredLocation: null })
      this.props.navigateToLocation(this.state.expiredLocation)
    }
  }

  confirmLocation = () => {
    if (this.state.expiredLocation) {
      this.props.confirmLocation(this.state.expiredLocation.id)
    }
  }

  onManuallyClose = () => {
    this.setState({ expiredLocation: null, isModalManuallyClosed: true })
  }

  render() {
    if (!this.state.expiredLocation) {
      return null;
    }

    return (
      <LocationExpiryModal 
        {...this.props} 
        expiredLocation={this.state.expiredLocation} 
        updateLocation={this.updateLocation}
        confirmLocation={this.confirmLocation}
        onClose={this.onManuallyClose} 
      />
    )
  }
}

const mapStateToProps = state => ({
  globalLocations: getGlobalLocations(state),
  representedLocations: getRepresentedLocations(state),
  currentLocationId: ""+state.table.currentLocation || state.router.location.pathname.split('/')[2] || null,
  isLoading: state.locationExpiry.loading
});

const mapDispatchToProps = (dispatch, { navigate, intl }) => ({
  confirmLocation: (locationId) => {
    dispatch(confirmLocation(locationId));
  },
  navigateToLocation: (location) => {
    navigate(`${intl.formatMessage({ id: 'settings.route.path' })}/${location.id}`)
  }
});

LocationExpiryContainer.propTypes = {
  globalLocations: PropTypes.array,
  representedLocations: PropTypes.array,
  currentLocationId: PropTypes.string,
  confirmLocation: PropTypes.func,
  navigateToLocation: PropTypes.func,
  roles: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(
      withAccessRights(
        LocationExpiryContainer
      )
    )
  )
)

